import { ofType } from "redux-observable";
import { mergeMap } from "rxjs/operators";

import "isomorphic-fetch";
import { polyfill } from "es6-promise";
import {
  DELETE_GROUP,
  deleteGroupFailed,
  deleteGroupSuccess,
} from "../actions/action_deleteGroup";
import util from "../../../global/utils/Helpers";
polyfill();

const getQuery = ({ email, subject, Group: { id } }) => {
  return JSON.stringify({
    query: `
            mutation {
                deleteGroup(
                  subjectid:"${subject}",
                  removeEmail:"${email}",
                  group_id:"${id}"
                )
          }`,
  });
};

const deleteGroupEpic = (action$) =>
  action$.pipe(
    ofType(DELETE_GROUP),
    mergeMap((action) =>
      fetch(util.getGqlApiUrl(), {
        credentials: "include",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: getQuery(action.payload),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.data.deleteGroup === 403) {
            return deleteGroupFailed(data);
          }
          if (data.errors) {
            return deleteGroupFailed(data.errors);
          } else {
            return deleteGroupSuccess(data);
          }
        })
        .catch((error) => {
          return deleteGroupFailed(error);
        })
    )
  );

export default deleteGroupEpic;
